import types from '@/vuex/relatorios/actions-types'
import documentos from '@/utils/documentos'
import relatorios from '@/utils/relatorios'

const actions = {
  [types.GET_LISTA_UNIDADES_PROCEDENCIA]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando lista de unidades de procedência' }, {root: true})
    try {
      const response = await documentos.getListaUnidadesProcedenciaRelatorios(payload.relatorio)
      commit(types.SET_LISTA_UNIDADES_PROCEDENCIA, { listaUnidadesProcedencia: response.data })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar unidades de procedência' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando lista de unidades de procedência' }, {root: true})
    }
  },

  [types.GERAR_PDF_GUIA_REMESSA_MALOTE]: async ({ commit }, payload) => {
    if (payload.parameters.idsUnidades.length <= 0) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Defina pelo menos uma unidade de procedência, juntamente com o intervalo de tempo' }, {root: true})
    } else {
      commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Gerando relatório de guia de remessa de malote' }, {root: true})
      try {
        const response = await relatorios.getPDFGuiaRemessaMalote(payload.parameters)
        const blob = new Blob([response.body], {type: 'application/pdf'})
        const blobURL = (window.URL || window.webkitURL).createObjectURL(blob)
        window.open(blobURL, '_blank')
      } catch (error) {
        commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível gerar o pdf do relatório' }, {root: true})
        throw error
      } finally {
        commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Gerando relatório de guia de remessa de malote' }, {root: true})
      }
    }
  },

  [types.GERAR_PDF_DOCUMENTOS_DESARQUIVADOS_SETOR]: async ({ commit }, payload) => {
    if (payload.parameters.idsUnidades.length <= 0) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Defina pelo menos uma unidade de procedência, juntamente com o intervalo de tempo' }, {root: true})
    } else {
      commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Gerando relatório de documentos desarquivados' }, {root: true})
      try {
        const response = await relatorios.getPDFDocumentosDesarquivadosSetor(payload.parameters)
        const blob = new Blob([response.body], {type: 'application/pdf'})
        const blobURL = (window.URL || window.webkitURL).createObjectURL(blob)
        window.open(blobURL, '_blank')
      } catch (error) {
        commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível gerar o pdf do relatório' }, {root: true})
        throw error
      } finally {
        commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Gerando relatório de documentos desarquivados' }, {root: true})
      }
    }
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/vuex/relatorios/actions.js